import React, { useEffect, useState } from 'react';
import { Input, Button, Modal, Radio, List, message, Form, Space } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import ImgUpload from '@/components/ImgUpload';
const { TextArea } = Input;
export default function WelcomeConfig(props) {
  const { fillData, callBack } = props;

  const layout = {
    // 标签长度
    labelCol: {
      span: 4,
    },
    // 表单长度
    wrapperCol: {
      span: 18,
    },
  };

  const [imageForm] = Form.useForm();
  const [mpForm] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [fileVisible, setFileVisible] = useState(false);
  const [linkVisible, setLinkVisible] = useState(false);
  const [linkDisabled, setLinkDisabled] = useState(false);
  const [miniVisible, setMiniVisible] = useState(false);
  const [miniDisabled, setMiniDisabled] = useState(false);
  const [imageVisible, setImageVisible] = useState(false);
  const [imageDisabled, setImageDisabled] = useState(false);
  const [coverImageList, setCoverImageList] = useState([]);

  const [linkForm] = Form.useForm();
  const [radioValue, setRadioValue] = useState();
  const [linkPictureList, setLinkPictureList] = useState([]);
  const [baseData, setBaseData] = useState({
    title: '',
    content: '',
  });
  const [miniImgList, setMiniImgList] = useState([]);

  useEffect(() => {
    // 数据回填
    setBaseData({
      // title: fillData?.title,
      content: fillData?.content, //欢迎语内容
    });
    let files = [];
    if (fillData?.link) {
      files = [
        {
          ...fillData?.link,
          type: 'link',
        },
      ];
      setLinkDisabled(true);
    } else {
      setLinkDisabled(false);
    }
    if (fillData?.miniProgram) {
      files = [
        ...files,
        {
          ...fillData?.miniProgram,
          type: 'mini',
        },
      ];
      setMiniDisabled(true);
    } else {
      setMiniDisabled(false);
    }

    if (fillData?.image) {
      files = [
        ...files,
        {
          ...fillData?.image,
          type: 'image',
          // title:
        },
      ];
      setImageDisabled(true);
    } else {
      setMiniDisabled(false);
    }
    setFileList(files);
  }, [fillData]);
  const onFileOk = () => {
    onFileCancel();
    if (radioValue === 1) {
      setLinkVisible(true);
    } else if (radioValue === 2) {
      setMiniVisible(true);
    } else if (radioValue === 3) {
      setImageVisible(true);
    }
  };
  const onFileCancel = () => {
    setFileVisible(false);
    setRadioValue('');
  };

  const onImageOk = () => {
    if (coverImageList.length < 1) {
      return message.error('请上传图片');
    }
    imageForm.validateFields().then((values) => {
      const index = fileList.findIndex((i) => i.type === 'image');
      if (index > -1) {
        const tempList = [...fileList];
        tempList[index] = {
          type: 'image',
          pic_url: coverImageList[0].url,
          title: values.title,
        };
        setFileList(tempList);
      } else {
        setFileList([
          ...fileList,
          {
            type: 'image',
            pic_url: coverImageList[0].url,
            title: values.title,
          },
        ]);
      }
    });
    setImageVisible(false);
    setImageDisabled(true);
  };
  const onImageCancel = () => {
    setImageVisible(false);
    imageForm.resetFields();
    setCoverImageList([]);
  };

  const onLinkOk = () => {
    linkForm.validateFields().then((values) => {
      if (linkPictureList.length === 0) {
        message.error('请上传封面图片');
        return;
      }
      // 校验
      const newT = /http[s]{0,1}:\/\/([\w.]+\/?)\S*/;
      if (!newT.test(values.picurl)) {
        message.error('链接地址以http或https开头');
        return;
      }

      // 小程序标题64字节 utf-8的字节数
      const byteLength = new TextEncoder().encode(values.title).length;
      if (byteLength > 128) {
        message.info('标题最长128字节');
        return;
      }

      const descLength = new TextEncoder().encode(values.desc).length;
      if (descLength > 512) {
        message.info('描述最长512字节');
        return;
      }

      const index = fileList.findIndex((i) => i.type === 'link');
      if (index > -1) {
        // 更改
        const tempList = [...fileList];
        tempList[index] = {
          type: 'link',
          ...values,
          realPicUrl: linkPictureList[0].url,
        };
        setFileList(tempList);
      } else {
        // 新增
        setFileList([
          ...fileList,
          {
            type: 'link',
            ...values,
            realPicUrl: linkPictureList[0].url,
          },
        ]);
      }

      onLinkCancel();
      setLinkDisabled(true);
    });
  };
  const onLinkCancel = () => {
    linkForm.resetFields();
    setLinkPictureList([]);
    setLinkVisible(false);
  };

  const onMiniOk = () => {
    mpForm.validateFields().then((values) => {
      if (miniImgList.length < 1) {
        return message.error('小程序封面图必填');
      }
      // 小程序标题64字节 utf-8的字节数
      const byteLength = new TextEncoder().encode(values.title).length;
      if (byteLength > 64) {
        message.info('小程序标题最长64字节');
        return;
      }
      const index = fileList.findIndex((i) => i.type === 'mini');
      if (index > -1) {
        const tempList = [...fileList];
        tempList[index] = {
          type: 'mini',
          ...values,
          url: miniImgList[0].url,
        };
        setFileList(tempList);
      } else {
        setFileList([
          ...fileList,
          {
            type: 'mini',
            ...values,
            url: miniImgList[0].url,
          },
        ]);
      }

      setMiniDisabled(true);
      onMiniCancel();
    });
  };
  const onMiniCancel = () => {
    mpForm.resetFields();
    setMiniImgList([]);
    setMiniVisible(false);
  };
  const onRadioChange = (e) => {
    setRadioValue(e.target.value);
  };
  const chooseFiles = () => {
    setFileVisible(true);
  };
  const editFileItem = (item, index) => {
    if (item.type === 'mini') {
      mpForm.setFieldsValue(item);
      setMiniImgList([{ url: item.url }]);
      setMiniVisible(true);
    } else if (item.type === 'link') {
      linkForm.setFieldsValue(item);
      setLinkPictureList([{ url: item.realPicUrl }]);
      setLinkVisible(true);
    } else if (item.type === 'image') {
      imageForm.setFieldsValue(item);
      setCoverImageList([{ url: item.pic_url }]);
      setImageVisible(true);
    }
  };
  const deleteFileItem = (item, index) => {
    if (item.type === 'mini') {
      setMiniDisabled(false);
    } else if (item.type === 'link') {
      setLinkDisabled(false);
    } else if (item.type === 'image') {
      setImageDisabled(false);
    }
    setFileList(fileList.filter((i, ind) => ind !== index));
  };
  const changeBaseData = (e, params) => {
    setBaseData({
      ...baseData,
      [params]: e.target.value,
    });
  };
  const renderContent = (data) => {
    if (data.type === 'link') {
      return <div style={{ wordBreak: 'break-all' }}>[链接]{data.picurl}</div>;
    } else if (data.type === 'mini') {
      return <div style={{ wordBreak: 'break-all' }}>[小程序]{data.title}</div>;
    } else if (data.type === 'image') {
      const filename = data.pic_url.split('/').pop();
      return (
        <div style={{ wordBreak: 'break-all' }}>
          [图片]{data.title}
          {filename}
        </div>
      );
    }
  };

  useEffect(() => {
    updateData();
  }, [baseData, fileList]);

  const updateData = () => {
    let params = {
      ...baseData,
    };
    const headIndex = fileList.findIndex((i) => i.type === 'link');
    if (headIndex > -1) {
      const obj = fileList[headIndex];
      // 链接不需要图片id
      params = {
        ...params,
        link: obj,
      };
    }
    const miniIndex = fileList.findIndex((i) => i.type === 'mini');
    if (miniIndex > -1) {
      const obj = fileList[miniIndex];
      // 参数
      const fixPicInfo =
        fillData?.miniProgram?.url === obj.url
          ? {
              pic_media_id: fillData?.miniProgram?.pic_media_id,
              original: fillData?.miniProgram?.original,
            }
          : {};
      params = {
        ...params,
        miniProgram: { ...obj, ...fixPicInfo },
      };
    }
    const imageIndex = fileList.findIndex((i) => i.type === 'image');
    if (imageIndex > -1) {
      const obj = fileList[imageIndex];
      // 参数
      const fixPicInfo =
        fillData?.image?.pic_url === obj.pic_url
          ? {
              media_id: fillData?.image?.media_id,
              original: fillData?.image?.original,
            }
          : {};
      params = {
        ...params,
        image: { ...obj, ...fixPicInfo },
      };
    }
    if (callBack) {
      callBack(params);
    }
    console.log(params);
  };
  return (
    <div>
      <TextArea
        value={baseData.content}
        onChange={(e) => changeBaseData(e, 'content')}
        rows={10}
        placeholder="1000个字符以内"
        maxLength={1000}
      />
      <div style={{ marginTop: 10 }}>
        {fileList.length > 0 ? (
          <List
            size="small"
            dataSource={fileList}
            bordered
            renderItem={(item, index) => (
              <List.Item
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <span>{renderContent(item)}</span>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'end',
                    flexShrink: 0,
                    minWidth: '45px',
                  }}
                >
                  {(item.type === 'mini' || item.type === 'link') && (
                    <EditOutlined
                      style={{ marginRight: '15px' }}
                      onClick={() => editFileItem(item, index)}
                    />
                  )}

                  <DeleteOutlined onClick={() => deleteFileItem(item, index)} />
                </div>
              </List.Item>
            )}
          />
        ) : null}

        <div style={{ marginTop: 10 }}>
          {fileList.length < 3 ? (
            <Button type="link" onClick={chooseFiles}>
              <PlusOutlined style={{ color: '#2db7f5' }} />
              添加图片/链接/小程序
            </Button>
          ) : null}
        </div>
        <Modal
          title="选择附件类型"
          visible={fileVisible}
          onOk={onFileOk}
          onCancel={onFileCancel}
          maskClosable={false}
          width={800}
        >
          <div>
            <Radio.Group
              onChange={(e) => {
                onRadioChange(e);
              }}
              value={radioValue}
            >
              <Radio value={3} disabled={imageDisabled}>
                图片
              </Radio>
              <Radio value={1} disabled={linkDisabled}>
                链接
              </Radio>
              <Radio value={2} disabled={miniDisabled}>
                小程序
              </Radio>
            </Radio.Group>
          </div>
        </Modal>

        <Modal
          title="添加图片"
          visible={imageVisible}
          onOk={onImageOk}
          onCancel={onImageCancel}
          width={800}
        >
          <Form
            {...layout}
            style={{ marginTop: 30 }}
            form={imageForm}
            name="edit"
          >
            <Form.Item name="title" label={'图片标题'}>
              <Input
                placeholder={'请输入，最长为128字符'}
                maxLength={128}
              ></Input>
            </Form.Item>

            <Form.Item
              label={
                <span>
                  <span style={{ color: 'red' }}>*</span> 上传图片
                </span>
              }
            >
              <ImgUpload
                // maxSize={5 * 1024 * 1024}
                imgList={coverImageList}
                setImgList={setCoverImageList}
              />
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title="添加链接"
          visible={linkVisible}
          onOk={onLinkOk}
          onCancel={onLinkCancel}
          width={800}
        >
          <Form
            style={{ marginTop: 30 }}
            {...layout}
            form={linkForm}
            name="edit"
          >
            <Form.Item
              name="title"
              label={'链接标题'}
              rules={[
                {
                  required: true,
                  message: '请输入',
                },
              ]}
            >
              <Input
                placeholder={'请输入链接的标题，最长为128字节'}
                maxLength={128}
              ></Input>
            </Form.Item>

            <Form.Item name="desc" label={'描述文字'}>
              <Input.TextArea
                allowClear
                bordered
                maxLength={512}
                showCount
                autoSize={{ minRows: 3, maxRows: 6 }}
                placeholder={'请输入描述，最长为512字节'}
              ></Input.TextArea>
            </Form.Item>

            <Form.Item
              name="picurl"
              label={'链接URL'}
              rules={[
                {
                  required: true,
                  message: '请输入',
                },
              ]}
            >
              <Input
                placeholder={'链接地址以http或https开头'}
                // maxLength={128}
              ></Input>
            </Form.Item>

            <Form.Item
              label={
                <span>
                  <span style={{ color: 'red' }}>*</span> 封面图片
                </span>
              }
            >
              {/* realPicUrl */}
              <Space
                style={{
                  paddingTop: '5px',
                  paddingBottom: '15px',
                  color: '#666666',
                }}
              >
                宽高比为1:1的图片JPG/PNG，因微信限制，大小需控制在100KB内
              </Space>
              <ImgUpload
                maxSize={100 * 1024}
                imgList={linkPictureList}
                setImgList={setLinkPictureList}
                whRatio={1}
              />
            </Form.Item>
          </Form>
        </Modal>
        <Modal
          title="添加小程序"
          visible={miniVisible}
          onOk={onMiniOk}
          onCancel={onMiniCancel}
          width={800}
        >
          <Form style={{ marginTop: 30 }} {...layout} form={mpForm} name="edit">
            <Form.Item
              name="title"
              label={'小程序标题：'}
              rules={[
                {
                  required: true,
                  message: '请输入',
                },
              ]}
            >
              <Input
                placeholder={'请输入链接的标题,最长为64字节'}
                // maxLength={64}
                // onChange={(e) => {
                //   const inputText = e.target.value;
                //   const byteLength = new TextEncoder().encode(inputText).length;
                //   console.log('输入字节数:', byteLength);
                // }}
              ></Input>
            </Form.Item>

            <Form.Item
              name="appid"
              label={'小程序APPID：'}
              rules={[
                {
                  required: true,
                  message: '请输入',
                },
              ]}
            >
              <Input placeholder={'请输入小程序APPID'}></Input>
            </Form.Item>

            <Form.Item
              name="page"
              label={'小程序路径：'}
              rules={[
                {
                  required: true,
                  message: '请输入小程序路径',
                },
              ]}
            >
              <Input placeholder={'请输入小程序路径'}></Input>
            </Form.Item>

            <Form.Item
              label={
                <span>
                  <span style={{ color: 'red' }}>*</span> 小程序封面
                </span>
              }
            >
              {/* realPicUrl */}
              <ImgUpload
                maxSize={2 * 1024 * 1024}
                imgList={miniImgList}
                setImgList={setMiniImgList}
              />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </div>
  );
}
